module.exports = __webpack_public_path__ + "img/lg_ring_y_0_null_null@3x.c1e38ad9.png";